import { useFetchPaginated } from '@/composables/front/common/useFetchPaginated';

export function usePedidos() {
    const { items: pedidos, fetch: fetchPedidos, ...rest } = useFetchPaginated({
        vuexAlias:    'front.perfil.v2.pedidos',
        errorMessage: 'Error al cargar pedidos',
    });
    return { pedidos, fetchPedidos, ...rest };
}
